import { modelHelperModule } from './model-helper';

export const noteModelModule = angular
  .module('Q.models.note', [modelHelperModule])

  .factory('Note', function (ModelHelper) {
    let Note = ModelHelper.defineResource({
      name: 'Note',
      endpoint: 'notes',
      methods: {},
      staticMethods: {
        // automatically loads notes for a given notable, and listens for changes to reload
        watchFor(notable, $scope) {
          const notableId = notable.id;
          const notableType = notable.$type || notable.constructor.name;

          let updatePromise = null;

          const updateEvent = () => {
            if (!updatePromise) {
              updatePromise = Note.findAll(
                { notableId, notableType },
                {
                  ignoreLoadingBar: true,
                  bypassCache: true,
                },
              ).finally(() => {
                updatePromise = null;
              });
            }
          };

          $scope.$on(
            `socket:model.changed:${notableType}:${notableId}`,
            updateEvent,
          );
          $scope.$on(`model.changed:${notableType}:${notableId}`, updateEvent);
        },
      },
      relations: {
        hasOne: {
          TeamMember: {
            localField: 'user',
            localKey: 'userId',
          },
          TeamCandidate: {
            localField: 'notable',
            localKey: 'notableId',
          },
        },
      },
    });

    return Note;
  });
